export default __webpack_public_path__ + "static/media/Q2.ea66bb9d.png";